import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { HeartHandshake, RefreshCw } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { DAILY_QUOTES } from "@/i18n/dailyQuotes";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

// Sorteia uma mensagem do banco existente, sem repetir a anterior
const drawIndex = (exclude) => {
  let i = Math.floor(Math.random() * DAILY_QUOTES.length);
  while (i === exclude) i = Math.floor(Math.random() * DAILY_QUOTES.length);
  return i;
};

// Botão "Receber minha mensagem" — abre a mensagem sorteada num modal (usado no hero)
export const PersonalMessageButton = ({ className }) => {
  const { t, lang } = useLanguage();
  const [open, setOpen] = useState(false);
  const [idx, setIdx] = useState(null);
  const quote = idx !== null ? DAILY_QUOTES[idx] : null;

  return (
    <>
      <button
        type="button"
        onClick={() => { setIdx(drawIndex(idx)); setOpen(true); }}
        data-testid="personal-receive-btn"
        className={className}
      >
        <HeartHandshake size={18} strokeWidth={1.5} />
        {t("personal.receive")}
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          data-testid="personal-message-modal"
          className="max-w-xl w-[92vw] bg-background text-foreground text-center px-8 py-10"
        >
          <DialogTitle className="sr-only">{t("personal.title")}</DialogTitle>
          <AnimatePresence mode="wait">
            {quote && (
              <motion.figure
                key={idx}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
              >
                <blockquote
                  className="font-serif italic text-xl sm:text-2xl leading-[1.4] text-foreground"
                  data-testid="personal-quote-text"
                >
                  <span aria-hidden className="text-primary/60 not-italic mr-1">“</span>
                  {quote.text[lang] || quote.text.pt}
                  <span aria-hidden className="text-primary/60 not-italic ml-1">”</span>
                </blockquote>
                <figcaption
                  className="mt-5 font-sans uppercase tracking-[0.18em] text-xs font-semibold text-foreground/80"
                  data-testid="personal-quote-author"
                >
                  {quote.author}
                  {quote.year && <span className="text-muted-foreground font-normal"> · {quote.year}</span>}
                </figcaption>
                <button
                  type="button"
                  onClick={() => setIdx(drawIndex(idx))}
                  data-testid="personal-another-btn"
                  className="mt-8 inline-flex items-center gap-2 px-6 py-3 font-sans text-sm text-muted-foreground hover:text-primary transition-colors duration-300"
                >
                  <RefreshCw size={14} strokeWidth={1.5} />
                  {t("personal.another")}
                </button>
              </motion.figure>
            )}
          </AnimatePresence>
        </DialogContent>
      </Dialog>
    </>
  );
};
